import { SyllabusModel } from "@/models/syllabus.model";
import { ref } from "@vue/reactivity";

export const loadedSyllabus = ref(undefined as SyllabusModel | undefined);